import React, { useEffect } from "react";
import PropTypes from "prop-types";

const ContactForm = ({ html, id, action, onSuccess, isHidden }, ref) => {
  useEffect(() => {
    const formWrappers = [...document.getElementsByClassName("wpcf7")];
    if (!isHidden) {
      formWrappers.filter((formWrapper) => {
        return formWrapper.querySelector('input[name="wpcf7"]')?.value === id;
      });
    }
    formWrappers.forEach((formWrapper) => {
      const form = formWrapper.querySelector("form");
      if (form) {
        form.addEventListener("submitForm", (e) => {
          e.preventDefault();

          if (typeof window !== "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              formTitle: undefined,
              customerType: undefined,
            });
            window.dataLayer.push({
              event: "gtm.formSubmit",
              formTitle: e?.detail?.formTitle,
              customerType: localStorage.getItem("private-business"),
            });
          }

          const data = new FormData(form);
          const req = new XMLHttpRequest();

          req.open("POST", action, true);
          req.onload = () => {
            form.querySelectorAll(".form-input-required").forEach((element) => {
              element.parentNode.removeChild(element.nextSibling);
              element.classList.remove("form-input-required");
            });
            if (req.status === 200) {
              const response = JSON.parse(req.response);
              formWrapper
                .querySelectorAll(".form-message")
                .forEach((element) => {
                  element.remove();
                });
              form.insertAdjacentHTML(
                "afterend",
                `<p class="form-message">${response.message}</p>`
              );
              if (response.status === "validation_failed") {
                response.invalid_fields.forEach((field) => {
                  const element = form.querySelector(field.into);
                  if (!element.classList.contains("form-input-required")) {
                    element.classList.add("form-input-required");
                    element.insertAdjacentHTML(
                      "afterend",
                      `<p class="form-input-required-message">${field.message}</p>`
                    );
                  }
                });
              } else if (response.status === "mail_sent") {
                if (onSuccess) {
                  onSuccess(response);
                }
                formWrapper
                  .querySelectorAll(".form-message")
                  .forEach((element) => {
                    element.remove();
                  });
                form.insertAdjacentHTML(
                  "afterend",
                  `<p class="form-message-success">${response.message}</p>`
                );
                form.remove();
              }
            }
          };
          req.send(data);
        });
      }
    });
  }, []);
  return (
    <div
      className="contactForm"
      dangerouslySetInnerHTML={{ __html: html }}
      ref={ref}
      style={{ display: isHidden ? "none" : "block" }}
    />
  );
};

export default React.forwardRef(ContactForm);

ContactForm.propTypes = {
  action: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  onSuccess: PropTypes.func,
  isHidden: PropTypes.bool,
};
